import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { OKGeneric } from '../../models';
import { apiAdminDispatch } from './contract.admin.dispatch';

extendZodWithOpenApi(z);
const c = initContract();

/**
 * Admin API
 * These runs via vercel.json's `crons` configuration, and as such must be GET requests.
 * @note when Vercel allows DELETE/POST requests, we should convert to that.
 */
export const apiAdmin = c.router({
  performDeletionsCleanup: {
    method: 'GET',
    path: `/1.0/admin/destroy/records_for_deletion`,
    summary: 'Performs deletion on records, users & accounts flagged for removal',
    description: 'Currently runs every hour',
    responses: {
      200: OKGeneric,
    },
  },
  installCategories: {
    method: 'GET',
    path: `/1.0/admin/install/categories`,
    summary: 'Installs categories. Runs every hour in prod via vercel.json',
    description:
      'Synchronizes the integration categories from the static configuration into the database. Ensures category definitions are up-to-date for organizing integrations in the UI. Triggered hourly via Vercel cron job in production.',
    responses: {
      200: OKGeneric,
    },
  },
  installNangoProviders: {
    method: 'GET',
    path: `/1.0/admin/install/nango-providers`,
    summary:
      'Installs Nango providers + Provider integrations. Runs every hour in prod via vercel.json',
    description:
      'Synchronizes Nango OAuth provider configurations and integration metadata from the provider definitions into the database. Ensures provider availability and authentication settings are current. Triggered hourly via Vercel cron job in production.',
    responses: {
      200: OKGeneric,
    },
  },
  installTools: {
    method: 'GET',
    path: `/1.0/admin/install/tools`,
    summary: 'Installs Tools. Runs every hour in prod via vercel.json',
    description:
      'Synchronizes tool definitions from the static configuration into the database. Tools represent different third-party applications that can be integrated. Triggered hourly via Vercel cron job in production.',
    responses: {
      200: OKGeneric,
    },
  },
  dispatch: apiAdminDispatch,
});
